import React from 'react';
import type { ViewState } from './types';

export interface ViewStateContextType {
	state: ViewState;
	setViewState: (stateChange: (prevState: ViewState) => ViewState) => void;
}

export const ViewStateContext = React.createContext<ViewStateContextType | null>(null);

export const useViewStateContext = () => {
	const context = React.useContext(ViewStateContext);
	if (context === null) {
		throw new Error('ViewStateContext is not defined');
	}
	return context;
};
